module.exports = __webpack_public_path__ + "img/icon-vot-searchforvote.04f5378f.png";